export enum ServiceProviderEmrConnectionStatus {
    Created = 1,
    Configured = 2,
    Disabled = 3,
    Deleted = 4
}
